<div
    class="bp-body builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : 'url(' + data.bg_thumbnail.url + ')'"
>
    <div
		class="bp-body-holder builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
    >
      	<div class="desc" [innerHTML]="trustedDescription"></div>
    </div>
</div>